<template>
    <a-modal title="血液成分"
             :width="1200"
             :visible="visible"
             @cancel="close"
             @ok="close">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item label="用户昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="用户手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入用户手机号" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="5" :sm="24">
              <a-form-item label="查询时间" prop="createTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createTime" format="YYYY-MM-DD" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['joe:blood/components:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['joe:blood/components:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['joe:blood/components:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
        <a-button type="primary" @click="handleExport" >
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['joe:blood/components:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['joe:blood/components:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['joe:blood/components:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['joe:blood/components:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-modal>
</template>

<script>
import { pageBloodComponents,listBloodComponents, delBloodComponents } from '@/api/joe/bloodComponents'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import moment from "moment";

export default {
  name: 'BloodComponents',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      visible: false,
      userId: null,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        isPrivate: null,
        bloodUricAcid: null,
        bloodCholesterol: null,
        bloodTriglyceride: null,
        nickname: null,
        mobile: null,
        createTime: null,
        bloodHighLipoprotein: null,
        bloodLowLipoprotein: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'nickname',

          align: 'center'
        },
        {
          title: '用户手机号',
          dataIndex: 'mobile',

          align: 'center'
        },
        {
          title: '是否私人模式',
          dataIndex: 'isPrivate',
          customRender: function (t) {
            if(t == 0) {
              return '否'
            } else {
              return '是'
            }
          },
          align: 'center'
        },
        {
          title: '血液成分检测尿酸值(微摩尔/升)',
          dataIndex: 'bloodUricAcid',
          align: 'center'
        },
        {
          title: '血液成分检测总胆固醇值(微摩尔/升)',
          dataIndex: 'bloodCholesterol',
          align: 'center'
        },
        {
          title: '血液成分检测甘油三酯值(微摩尔/升)',
          dataIndex: 'bloodTriglyceride',
          align: 'center'
        },
        {
          title: '血液成分检测高密度脂蛋白(微摩尔/升)',
          dataIndex: 'bloodHighLipoprotein',
          align: 'center'
        },
        {
          title: '血液成分检测低密度脂蛋白(微摩尔/升)',
          dataIndex: 'bloodLowLipoprotein',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },

      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getUserBody(record) {
      this.userId = record
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
      this.$emit('close')
    },
    /** 查询用户血液成分检测记录列表 */
    getList () {
      this.loading = true
      this.queryParam.userId = this.userId
      if (moment.isMoment(this.queryParam.createTime)) {
        this.queryParam.createTime = this.queryParam.createTime.format('YYYY-MM-DD')
      }
     pageBloodComponents(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        isPrivate: undefined,
        bloodUricAcid: undefined,
        bloodCholesterol: undefined,
        bloodTriglyceride: undefined,
        bloodHighLipoprotein: undefined,
        bloodLowLipoprotein: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delBloodComponents(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      that.queryParam.userId = this.userId
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('joe/user-blood-components/export', {
            ...that.queryParam
          }, `用户血液成分检测记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
<style scoped>
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.pagination-container {
  margin-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
}

.ant-table-pagination {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.ant-pagination {
  display: inline-block;
  margin: 0 auto;
}
</style>